const Ppc = {
  symbol: 'ppc',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" fill-rule="evenodd" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM9 7.5v9.209c0 5.05 3.75 9.433 8.883 8.626 3.015-4.42.406-11.267-6.06-15.115 8.127 3.359 9.788 9.44 8.911 14.493-.047.266-.109.527-.169.787 1.482-1.028 2.187-2.014 2.85-3.817C25.756 15.206 21.093 7.947 9 7.5z"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" r="16" fill="#3CB054"/><path fill="#FFF" d="M9 7.5c12.093.447 16.756 7.706 14.415 14.183-.663 1.803-1.368 2.79-2.85 3.817.06-.26.122-.52.17-.787.876-5.053-.785-11.134-8.912-14.493 6.466 3.848 9.075 10.695 6.06 15.115C12.75 26.142 9 21.759 9 16.709V7.5z"/></g>`;
  }
};
export default Ppc;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/ppc.js
// module id = null
// module chunks = 